<template>
    <div class="qrcode-background" @click="qrcodeClick">
        <div class="qrcode-outbox">
            <div class="qrcode-box" ref="qrcode" style="height: 100%"></div>
            <img class="qrcode-logo" src="@/assets/img/face_demo_logo.png"/>
            <div class="qrcode-detail">使用手机扫码下载试用</div>
            <div class="qrcode-prompt">试用版暂只支持Android系统，正式版SDK可用于Android系统，iOS系统</div>
        </div>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2'

    export default {

        name: "MQrcode",
        props: {
            conditions: {
                width: String,
                url: String
            }
        },
        mounted() {
            this.createQrcode(this.conditions.url);
        },
        methods: {
            createQrcode(url) {
                let qrcodeObj = this.$refs.qrcode;
                qrcodeObj.innerHTML = '';
                var qrcode = new QRCode(qrcodeObj, {
                    text: encodeURI(url),
                    width: 150,
                    height: 150,
                });
            },
            qrcodeClick() {
                this.$emit('hideQrCode');
            }
        },
    }
</script>

<style scoped>

    .qrcode-background {
        position: absolute;
        top: 98px;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.4);
    }

    .qrcode-outbox {
        position: relative;
        background-color: white;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 240px;
        border-radius: 5px;
        margin: 200px auto auto;
    }

    .qrcode-outbox:hover {
        box-shadow: 10px 10px 5px #656B79;
    }


    .qrcode-logo {
        position: absolute;
        left: 100px;
        top: 105px;
        width: 40px;
        height: 40px;
    }

    .qrcode-box {
        margin-top: 50px;
    }

    .qrcode-detail {
        margin-top: 20px;
        font-size: 16px;
        color: black;
    }

    .qrcode-prompt {
        margin: 15px 10px 20px;
        /*margin-top: 15px;*/
        font-size: 12px;
        color: #3c3c3c;
        text-align: center;
    }

</style>